import _SegmentationUtil from './../_SegmentationUtil';

export default [function () {
    return {
        restrict: 'EA',
        controller: ['$element', '$q', 'brandingData', function ($element, $q, brandingData) {
            return _SegmentationUtil($element, $q.resolve(brandingData));
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/branding/BrandingSegmentationDirective.js
// module id = 1063
// module chunks = 0